export default __webpack_public_path__ + "static/media/vivabonito10.569a51e1.jpg";